// extracted by mini-css-extract-plugin
export default {"overlay":"NewFaceListPage_overlay__gdbfw","modal":"NewFaceListPage_modal__bo7mj","image":"NewFaceListPage_image__NqX8t","closeButton":"NewFaceListPage_closeButton__EAyB5"};